var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._g({tag:"component",class:['Btn', {'with-icon': _vm.icon}],attrs:{"href":_vm.href,"target":_vm.target,"rel":"noopener","type":_vm.type}},_vm.$listeners),[_vm._t("default"),_vm._v(" "),(_vm.icon)?_c('icon',{staticClass:"btn-icon",attrs:{"name":_vm.icon}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }